module.exports = __webpack_public_path__ + "static/media/Original Korean - Teaching - Prayer.02ef84bd.txt";